module.exports = __webpack_public_path__ + "assets/img/00185.fad4dae9.png";